import type { ContactStatus } from "features/contacts/blocks/PersonContact/PersonContact.types";
import type { ContactsListResponse } from "features/contacts/data/types";

export const detectStatus = (
  contacts: ContactsListResponse,
  targetPersonId: number,
): ContactStatus => {
  if (contacts.mutual_contacts.some((p) => p.id === targetPersonId))
    return "mutual";
  if (contacts.my_requests.some((p) => p.id === targetPersonId))
    return "my_request";
  if (contacts.their_requests.some((p) => p.id === targetPersonId))
    return "their_request";

  return "none";
};

export const getStatusLabel = (status: ContactStatus): string => {
  if (status === "my_request") return "Запрос уже отправлен";
  if (status === "mutual") return "Уже в ваших контактах";
  if (status === "their_request")
    return "Этот человек отправил вам запрос на контакты";

  return "";
};
